export class TabModel {
    public tabItems: TabItemModel[];
    public currentTabItem: TabItemModel;
    constructor(tabItems: TabItemModel[]) {
        this.tabItems = tabItems;
        this.active(this.tabItems[0]);
    }

    public active(tabItem: TabItemModel) {
        this.tabItems.forEach((ti: TabItemModel) => {
            ti.deactivate();
        });
        tabItem.activate();
        this.currentTabItem = tabItem;
    }
}

export class TabItemModel {
    public id: number;
    public value: string;
    public active: boolean;
    constructor(id: number, value: string, active: boolean = false) {
        this.id = id;
        this.value = value;
        this.active = active;
    }

    public toggle() {
        this.active = !this.active;
    }

    public activate() {
        this.active = true;
    }

    public deactivate() {
        this.active = false;
    }
}
